import React from "react";
import { Integration } from "model/integration";
import { TopProducerLtsIntegration } from "./top-producer-lts";
import { CustomLtsIntegration } from "./custom-lts";
import { ZapierNewLeadIntegration } from "./zapier-new-lead";
import { LeadAggregationIntegration } from "./lead-aggregation";
import { ZillowTechConnectIntegration } from "./zillow-tech-connect";
import { EmailCalendarIntegration } from "./email-calendar";
import { GoogleLoginIntegration } from "./google-login";
import { WixIntegration } from "./wix-app";
import { FacebookIntegration } from "./facebook";
import { ClientEventWebhookIntegration } from "./client-event-webhook";
import { FollowUpBossIntegration } from "./follow-up-boss";

interface Props {
	integration: Integration;
	autoOpenModal?: boolean;
	onAutoOpenHandled?: () => void;
}

class Component extends React.Component<Props> {

	public render() {
		const { integration, autoOpenModal, onAutoOpenHandled } = this.props;
		return (
			<>
				{integration.integrationType.topProducerLts && (
					<TopProducerLtsIntegration integration={integration} />
				)}
				{integration.integrationType.customLts && (
					<CustomLtsIntegration integration={integration} />
				)}
				{integration.integrationType.zapierNewLead && (
					<ZapierNewLeadIntegration integration={integration} />
				)}
				{integration.integrationType.leadAggregation && (
					<LeadAggregationIntegration integration={integration} />
				)}
				{integration.integrationType.zillowTechConnect && (
					<ZillowTechConnectIntegration integration={integration} />
				)}
				{integration.integrationType.emailCalendar && (
					<EmailCalendarIntegration integration={integration} />
				)}
				{integration.integrationType.googleLogin && (
					<GoogleLoginIntegration integration={integration} />
				)}
				{integration.integrationType.wixApp && (
					<WixIntegration integration={integration}/>
				)}
				{integration.integrationType.facebook && (
					<FacebookIntegration integration={integration}/>
				)}
				{integration.integrationType.clientEventWebhook && (
					<ClientEventWebhookIntegration integration={integration} />
				)}
				{integration.integrationType.followUpBoss && (
					<FollowUpBossIntegration
						integration={integration}
						autoOpenModal={autoOpenModal}
						onAutoOpenHandled={onAutoOpenHandled}
					/>
				)}
			</>
		);
	}

}

export const EditForm = Component;
